import FeaturedCard from "./FeaturedCard";
import { Content } from "components/Section/SectionContentFull";
import { useGoogleAnalyticsContext } from "contexts";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { WsDialogs } from "interfaces";
import FTUEInfoButton from "../FTUEInfoButton";

function LoyaltyLearnMoreCard({
	hasFTUEInfoButton
}: {
	hasFTUEInfoButton?: boolean;
}) {
	const { openDialog } = useDialogModalRedux();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const handleClick = () => {
		openDialog(WsDialogs.LOYALTY_FAQ);

		reportEvent("loyalty_learn_more_click", {
			source: "loyalty_page"
		});
		reportEvent("dialog_shown", { source: "loyalty_faq_dialog" });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "dialog_shown",
			event_type: "loyalty_faq_dialog",
			action: "dialog_shown",
			source: "loyalty_faq_dialog"
		});
	};

	return (
		<section className="loyalty-faq-section" data-testid="loyaltyFaqSection">
			<Content sx={{ marginTop: 3, position: "relative" }}>
				{hasFTUEInfoButton && <FTUEInfoButton className="learn-more-card" />}
				<FeaturedCard
					ctaClick={handleClick}
					ctaText="Learn More"
					backgroundColor="#34241e"
					textColor="white"
					backgroundImageUrl={
						"/spec_loyalty_faq/loyalty_faq_v4_{image_variant_1}.png"
					}
					titleText="Tiki TriPeaks Loyalty Points!"
					text="Everything you need to know about"
				/>
			</Content>
		</section>
	);
}

export default LoyaltyLearnMoreCard;
